class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    if(document.querySelector("#Details-menu-drawer-container").hasAttribute("open")){
      document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
      document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
      document.querySelector(".header__icon--menu").setAttribute("aria-expanded",false);
      document.body.classList.remove("overflow-hidden-tablet");
      document.querySelector(".section-header").classList.remove("menu-open");
    }
    if(document.querySelector(".header__search details").hasAttribute("open")){
      document.querySelector(".header__search details").removeAttribute("open");
      document.querySelector(".section-header").classList.remove("menu-open");
    }
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


//Coupon Code
class PromoCodeSection extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.target.classList.contains('cart-coupon-main') ? this.querySelector('.promo-code-wrap').classList.toggle('open') : null;
  
    });
  }
}

customElements.define('promo-code-wrap', PromoCodeSection);


class CartCouponCodeButton extends HTMLElement {
  constructor() {
    super();
    let current_form = this;
    this.querySelector('#coupon-form').addEventListener('submit', (event) => {

      event.preventDefault();
      this.submitForm(current_form.querySelector('.promo-input.couponCode').value)
    });
  }
 

   applyCouponCode(discountCode) {
    return new Promise((resolve, reject) => {
      let discountApplyUrl = "https://" + window.location.host + "/discount/" + discountCode;
  
      // Create a hidden iframe to apply discount using the checkout session
      let i = document.createElement('iframe');
      i.style.display = 'none';
      
      // Success: Remove iframe after it loads and log success message
      i.onload = function() {
        // console.log("Discount code applied successfully."); // Log success
        i.parentNode.removeChild(i); // Clean up the iframe
        resolve(); // Resolve the promise for success
      };
  
      // Error: Handle iframe loading error
      i.onerror = function() {
        console.error("Failed to apply discount code."); // Log error message
        i.parentNode.removeChild(i); // Clean up the iframe
        reject(new Error("Failed to apply discount code.")); // Reject with error
      };
  
      i.src = discountApplyUrl;
      document.body.appendChild(i); // Append iframe to the body
    });
  }
  
  submitForm(discountCode){
    const code = (discountCode || '').trim();
    if (!code) return;
    const entered = code.toLowerCase();

    // 1. Check the cart's CURRENT discount codes first. cart.discount_codes only
    //    contains manually-entered codes (never automatic / line-item discounts
    //    like "20% off the summer collection"), so it's a clean signal for coupons.
    fetch(`${routes.cart_url}.js`)
      .then((res) => res.json())
      .then((cartBefore) => {
        const already = (cartBefore.discount_codes || []).find(
          (d) => (d.code || '').toLowerCase() === entered && d.applicable
        );
        if (already) {
          this.showCouponMessage('already', code);
          return;
        }

        // 2. Apply the code, then re-read the cart to see if it actually took.
        this.applyCouponCode(code)
          .then(() => fetch(`${routes.cart_url}.js`).then((res) => res.json()))
          .then((cartAfter) => {
            const match = (cartAfter.discount_codes || []).find(
              (d) => (d.code || '').toLowerCase() === entered
            );

            // TEMP DIAGNOSTIC — remove once verified. Tells us whether Shopify
            // added the code at all, and its `applicable` flag / cart discounts.
            console.log('[coupon] entered:', code);
            console.log('[coupon] cart.discount_codes:', cartAfter.discount_codes);
            console.log('[coupon] cart.cart_level_discount_applications:', cartAfter.cart_level_discount_applications);
            console.log('[coupon] match:', match);

            // NOTE: the storefront cart API can't tell "code doesn't exist" apart
            // from "code exists but isn't applicable" — both come back as an entry
            // with applicable:false (or no entry). So there are only two outcomes:
            // applied, or not applied.
            const valid = !!(match && match.applicable);
            const status = valid ? 'valid' : 'invalid';

            // Re-render the drawer to reflect any price/discount change.
            fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
              .then((response) => response.json())
              .then((response) => {
                const cart_drawer = document.querySelector('cart-drawer');
                cart_drawer.renderContents({ sections: response });
                this.showCouponMessage(status, code);
              });
          })
          .catch((error) => {
            console.error("Error applying discount:", error.message);
            this.showCouponMessage('invalid', code);
          });
      })
      .catch((error) => {
        console.error("Error reading cart:", error.message);
        this.showCouponMessage('invalid', code);
      });
  }

  // status: 'valid' | 'invalid' | 'already'
  showCouponMessage(status, code){
    // Wait for renderContents (which re-renders the coupon form) to settle.
    setTimeout(() => {
      const wrap = document.querySelector('.promo-code-wrap');
      const errorEl = document.querySelector('cart-coupon-form .error');
      const successEl = document.querySelector('cart-coupon-form .coupon-success');
      const infoEl = document.querySelector('cart-coupon-form .coupon-info');
      const input = document.querySelector("cart-coupon-form input[type='text']");

      if (wrap) wrap.classList.add('open');
      [errorEl, successEl, infoEl].forEach((el) => el && el.classList.add('d-none'));

      if (status === 'valid') {
        successEl && successEl.classList.remove('d-none');
        if (input) input.value = '';
      } else if (status === 'already') {
        infoEl && infoEl.classList.remove('d-none');
        if (input) input.value = code;
      } else {
        errorEl && errorEl.classList.remove('d-none');
        if (input) input.value = code;
      }
    }, 300);
  }
}

customElements.define('cart-coupon-form', CartCouponCodeButton);




